//import React from "react";
import React, { useState, useEffect, useContext } from 'react';

// react component for creating dynamic tables
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import {transformValueFloattoFormated} from "beaktShared/helpers/masks";

import { useGetApi, UsePostApi, UsePutApi, UseDeleteApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";
import ServicoForm from "./ServicoForm";

import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import Dashboard from 'beaktClinic/views/Home';
import { UseGetApiSimple } from 'beaktShared/services/crudeApiService';
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function ServicoList() {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const endPoint = 'servicos/';  
   
    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});          
    const [loadingForm, setLoadingForm] = React.useState(false);

    const getEndPoint = () => {
        let endPointGet = "";
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            endPointGet =  endPoint +"byfranquia/"+ session.franquiaId;
        else //Acessando tela pelo modulo Clinica   
            endPointGet = endPoint +"byestabelecimento/"+ session.estabelecimentoId;
        return  endPointGet;
    }
    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi(getEndPoint());

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);       
    };
  
    const handleAdd = item => {

        var vefifyExists = list.filter(obj => {
            return obj.servicoId === item.servicoId;
        });

        if(vefifyExists.length > 0)
        {
            setLoadingForm(true);            
            UsePutApi(endPoint, session.id + "/" + item.servicoId, item).then(result=>{
                if(result.status !== 201)
                {                                    
                    showNotification(result.message.message,'danger');
                    return false; 
                }
                    
                const updateList = list.map(l => (l.servicoId === result.data.servicoId ? result.data : l));
                setListAtualiza(updateList);
                setLoadingForm(false);
                handleView(true);
                showNotification(result.message,'success');
                return true;                 
            });             
        }
        else
        {    
            setLoadingForm(true);
            UsePostApi(endPoint,item).then(result=>{               
                setLoadingForm(false); 
                if(result.status !== 201)
                {                                     
                    showNotification(result.message.message,'danger');
                    return false; 
                } 
                
                const addItemList = [...list, result.data];
                setListAtualiza(addItemList);   
                handleView(true);
                showNotification(result.message,'success');
                return true;                
            });         
        }

        return false;        
    };   

    const handleView = (resetItem) => {    
        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);             
    };

    const [detailModal, setConfModal] = GerenciaModal();
    const handleDetail = row => {  
        
        let endpoints = "servicos/pacotesservico/";
        if (session.estabelecimentoId == 0)
            endpoints += 0 + "/" + row.servicoId;
        else
            endpoints += session.estabelecimentoId + "/" + row.servicoId;
        UseGetApiSimple(endpoints,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message.message,'danger');
                return false; 
            }  

            const bodyDetail=(
            <div>
                <p><b>{t('dashboard.services')}:</b> {row.descricao}</p>
                <p><b>{t('information_message.runtime')}:</b> {row.tempoExecucao}</p>
                <p><b>{t('label.status')}</b> {row.ativo === true ? t('label.active') : t('label.inactive')}</p>
                {
                    session?.habilitaControleRoyalties &&
                    <>
                        <p>
                            <b>{'Controla Royalties'}</b> {row.incluirRoyaltie === true ? t('label.yes') : t('label.not')}
                        </p>
                    </>
                }
                <p><b>{'Pacotes vinculados á esse serviço:'}</b></p>         
                    {result.data.map((m, key) => {
                        return <p key={key}>{'Pacote: ' + m.pacote + ' - Estabelecimento: ' + m.estabelecimento}</p>
                    })}
            </div>);

            setConfModal({
                showmodal: true,
                dataShow: bodyDetail
            });

          return true;                
        });  
    };

    const handleEdit = row => {       
        setItem(row);
        handleView(false);
    };

    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const handleDelete = id =>
    {
        var userDeletadoId = session.id;
        var estabelecimentoId = session.estabelecimentoId;
        
        UseDeleteApi(endPoint, id, userDeletadoId, estabelecimentoId).then(result => 
        {
            if(result.status !== 200)
            {                                    
                setAlertDelete({statusAlert:2});
                showNotification(result.message,'danger');
                return false; 
            }

            var listFiltered = list.filter(obj => {
                return obj.servicoId !== id;
            });
            setListAtualiza(listFiltered);                
            setAlertDelete({statusAlert:3}); 
            return true;
        });         
    };

    const showAlertDelete = id =>{
        setAlertDelete({
            statusAlert:1,
            idToDeleteRecieve:id
        }); 
    }  
    useEffect(() => 
    {
        if(alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);  
    // eslint-disable-next-line        
    }, [alertDelete]);

    const columnsProp = [{
        Header: t('label.description'),
        accessor: "descricao"
    },
    {
        Header: t('label.value'),
        accessor: "valor",
        Cell: (row) => {
            return transformValueFloattoFormated((row.original.valor != null ? row.original.valor : 0))
        }
    },
    {
        Header: t('information_message.runtime'),
        accessor: "tempoExecucao"
    },
    {
        Header: t('label.status'),
        accessor: "ativo",
        Cell: (row) => { 
            if (row.original.ativo)
                return "Ativo"
            else
                return "Inativo"
        },
    },
    ...(session?.habilitaControleRoyalties ? [
        {
        Header: "Controla Royalties",
        accessor: "incluirRoyaltie",
        Cell: (row) => {
            return row.original.incluirRoyaltie ? 'Sim' : 'Não';
        },
        }
    ] : [])
    ];

    const columJustClinica = [
        {
            Header:t('register.bulletin_status'),
            accessor: "bloqueadoVenda",
            show: session.estabelecimentoFranqueado,
            Cell: (row) => { 
                if (row.original.bloqueadoVenda)
                    return t('label.blocked')
                else
                    return t('label.released')
            }
        }  
    ];
    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => {
            const item = row.original;
            const isCadastradoFranquia = Boolean(item.cadastradoFranquia);
            const tipoPerfil = session.tipoPerfil;
            const estabelecimentoId = session.estabelecimentoId;

            const podeEditar = (
                (!isCadastradoFranquia) ||
                (isCadastradoFranquia && tipoPerfil === 4) || 
                (tipoPerfil === 0 && estabelecimentoId === 0)
            );
            
            return (
                <div className="actions-right">
                <Button
                    justIcon
                    round
                    simple
                    color="info"
                    className="info"
                    onClick={() => handleDetail(item)}
                >
                    <Tooltip
                    title={t('label.detail')}
                    id="tooltip-top"
                    placement="top"
                    classes={{ tooltip: classes.tooltip }}
                    >
                    <Search />
                    </Tooltip>
                </Button>{" "}
                {podeEditar && (
                    <>
                    <Button
                        justIcon
                        round
                        simple
                        color="success"
                        className="edit"
                        onClick={() => handleEdit(item)}
                    >
                        <Tooltip
                        title={t('label.to_edit')}
                        id="tooltip-top"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                        >
                        <Edit />
                        </Tooltip>
                    </Button>{" "}
                    <Button
                        justIcon
                        round
                        simple
                        color="danger"
                        className="remove"
                        onClick={() => showAlertDelete(item.servicoId)}
                    >
                        <Tooltip
                        title={t('button.delete')}
                        id="tooltip-top"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                        >
                        <Close />
                        </Tooltip>
                    </Button>{" "}
                    </>
                )}
                </div>
            );
            },
            sortable: false,
            filterable: false
        }
    ];
    
    let columns = "";
    if(session.estabelecimentoId === 0)
        columns = [...columnsProp, ...columnsAcao]
    else 
        columns = [...columnsProp, ...columJustClinica, ...columnsAcao]  

    const classes = useStyles();
    return (
        <div>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {showFormView && 
                <ServicoForm addItem={handleAdd} item={item} handleView={handleView} loading={loadingForm} />} 
            
            {!showFormView &&
                <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('register.list_of_services')}</h4>
                        </CardHeader>
                        <CardBody>
                            <Button
                                color="primary"
                                className={classes.newButton}
                                onClick={() => handleView(true)}
                            >
                                {t('button.new')}
                            </Button>                           

                            {isErrorGetList && <div>Erro ao carregar dados...</div>}
                            <ReactTable
                                loading = {isLoadingList}
                                data={list}
                                columns={columns}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
            }
            
            {alertDelete.componente}
            {detailModal}            
        </div>
    );
}
